import { render, staticRenderFns } from "./BaseScrollableTable.vue?vue&type=template&id=090c27cc&scoped=true&"
import script from "./BaseScrollableTable.vue?vue&type=script&lang=js&"
export * from "./BaseScrollableTable.vue?vue&type=script&lang=js&"
import style0 from "./BaseScrollableTable.vue?vue&type=style&index=0&id=090c27cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090c27cc",
  null
  
)

export default component.exports